export default __webpack_public_path__ + "static/media/js-es6.7f86c0d1.png";